module.exports = __webpack_public_path__ + "static/media/linkedin.f7be25f2.png";